<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class=" pb-4 text-center">
        <h4 *ngIf="active">{{'MEMBERS.CONFIRM_COMPANY_SUSPEND'|translate}}</h4>
        <h4 *ngIf="!active">{{'MEMBERS.CONFIRM_COMPANY_UNSUSPEND'|translate}}</h4>
    </div>
    <div class="d-flex flex-row justify-content-between pb-4">
        <button *ngIf="active" class="btn_in_color" (click)="suspendcompany()">{{ 'MEMBERS.SUSPEND' |
            translate | uppercase}}</button>
        <button *ngIf="!active" class="btn_in_color" (click)="unsuspendcompany()">{{ 'MEMBERS.UNSUSPEND' |
            translate | uppercase}}</button>
        <button class="btn_without_color" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
</div>
